import { render, staticRenderFns } from "./MembersList.vue?vue&type=template&id=c536a506&"
import script from "./MembersList.vue?vue&type=script&lang=js&"
export * from "./MembersList.vue?vue&type=script&lang=js&"
import style0 from "./MembersList.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports